/*
 * @Author: leventlei
 * @Date: 2024-01-09 19:59:55
 * @LastEditTime: 2024-01-09 20:29:00
 * @LastEditors: leventlei
 * @Description: 带有悬浮提示的表单label
 * @FilePath: /IOT4CMS/src/components/FormLableWithToolTip/index.tsx
 */
import { QuestionCircleFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React, { FC } from 'react'
import './index.less'

interface FormLabelWithToolTipProps {
	label: string // 表单label
	toolTipContent?: string // 提示内容
}

const FormLabelWithToolTip: FC<FormLabelWithToolTipProps> = ({
	label,
	toolTipContent,
}) => {
	return (
		<div className="formLabelWithToolTipProps">
			<span>{label}</span>
			{toolTipContent && (
				<Tooltip title={toolTipContent} placement="right">
					<QuestionCircleFilled
						style={{
							color: '#7D7D7D',
						}}
					/>
				</Tooltip>
			)}
		</div>
	)
}

export default FormLabelWithToolTip
